import React from 'react';
import EducationArticles from '../../containers/Education/EducationArticles';

export class EducationArticlesPage extends React.Component {
  render() {
    return (
      <EducationArticles />
    );
  }
}